import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
// Redux
import { connect } from 'react-redux';
import { toggleCollapsedNav } from '../../../redux/action/Theme';
import { logNotFound } from '../../../services/LoggingService';


const Error404 = ({ toggleCollapsedNav }) => {

    // DEBUGGING ONLY
    const location = useLocation();
    const fromPath = location.state?.from; // Access the 'from' property from the state

    console.log("Error404: useLocation: ", location.pathname);
    console.log("Error404: FROM PATH: ", fromPath);

    logNotFound(fromPath);

    // useEffect(() => {
    //     toggleCollapsedNav(false);
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [])

    return (
        <Container>
            <div className="hk-pg-body">
                <Row>
                    <Col xl={7} lg={6} className="d-lg-block d-none">
                        <div className="auth-content py-md-0 py-8">
                            <Row>
                                <Col xl={12} className="text-center">
                                    {/* <img src={fatalErrorImg} className="img-fluid w-sm-80 w-50" alt="login" /> */}

                                    <h1 className="text-warning" style={{ fontSize: '15em' }}>
                                        <i className="bi bi-question-circle"></i>
                                        {/* <i className="bi bi-exclamation-circle"></i> */}
                                    </h1>

                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col xl={5} lg={6} md={7} sm={10}>
                        <div className="auth-content py-8">
                            <div className="w-100">
                                <Row>
                                    <Col xxl={9} xl={8} lg={11}>
                                        <h1 className="display-4 fw-bold mb-2">404</h1>
                                        <p className="p-lg">Sorry, the requested page cannot be found. Try finding with another name.</p>

                                        <br />
                                        <h4>
                                            <pre>
                                            REQUESTED PAGE: {fromPath ? fromPath : "No previous path found"}
                                            </pre>
                                            <pre>
                                            LOCATION: {location ? location.pathname : "No location path found"}
                                            </pre>
                                        </h4>
                                        <br />

                                        <Button variant="primary" as={Link} to="/" className="mt-4"><i className="bi bi-house-door-fill me-2"></i>Return to Home Page</Button>

                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </Container>
    )
}

const mapStateToProps = ({ theme }) => {
    const { navCollapsed } = theme;
    return { navCollapsed }
};

export default connect(mapStateToProps, { toggleCollapsedNav })(Error404);